var _clipPath, _clipPath2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnglish(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 30",
    width: 1200,
    height: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 v30 h60 v-30 z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 v30 h60 v-30 z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L60,30 M60,0 L0,30",
    stroke: "#fff",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L60,30 M60,0 L0,30",
    clipPath: "url(#t)",
    stroke: "#C8102E",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,0 v30 M0,15 h60",
    stroke: "#fff",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,0 v30 M0,15 h60",
    stroke: "#C8102E",
    strokeWidth: 6
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglish);
export default __webpack_public_path__ + "static/media/english.8c3d2102446be2711b46b83bef6cc68e.svg";
export { ForwardRef as ReactComponent };